
<div mat-dialog-title>Loss Target & Priority<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div class="block">
    <label style="width:100px;display: inline-block;">Amount</label>
    <irb-number-text-box width="100px"  [(value)]="selectedAmount" (keyup)="onAmountChange()"></irb-number-text-box>
  </div>
  <div>
    <label style="width:100px;display: inline-block;">Loss Priority</label>
    <irb-dropdown-filter #IrbSelectedLossTypeDropdown
        id="irbSelectedRebalanceTypeDropdown"
        [(value)]="selectedLossPriority"
        (search)="setChainTypeOptions()"
        size="58"
        hoverPanelWidth="450"
        [disabled]="!selectedLossPriority"
    ></irb-dropdown-filter>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button id="continueButton" (click)="submitFile()" class="btn-medium-primary">Continue</button>
</mat-dialog-actions>
